<template>
    <dropdown-filter
        @change="$emit('input', $event)"
        :value="value"
        :label="label"
        :options="elements"
        :loading="loading"
    />
</template>

<script>
import $fetch from 'wee-fetch';
import DropdownFilter from '../dropdown-filter/index.vue';

export default {
    components: {
        DropdownFilter,
    },
    props: {
        section: {
            type: String,
        },
        hasAll: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        value: {
            type: String,
            default: '',
        },
    },
    mounted() {
        this.loading = true;

        $fetch.get(`/${this.section}.json`)
            .then(({ data }) => {
                this.elements = data.data.map(item => ({
                    key: item.title,
                    value: item.title,
                }));

                if (this.elements.length && this.hasAll) {
                    // Add blank option
                    this.elements.unshift({
                        key: 'All',
                        value: 'All',
                    });
                }

                if (this.placeholder) {
                    // Add blank option
                    this.elements.unshift({
                        key: this.placeholder,
                        value: this.placeholder,
                    });
                }

                this.loading = false;
            }).catch(e => console.error(e));
    },
    data: () => ({
        elements: [],
        loading: false,
    }),
}
</script>
